import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";

export const MainWrapper = styled.div`
  height: 100vh;
  display: flex;
`;

export const LeftSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 50%;
`;

export const RightSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 50%;

  position: relative;
`;

export const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${() => `${viewSizeCalculator(2)}`};

  width: 50%;
`;

export const Heading = styled.h3`
  font-size: ${() => `${viewSizeCalculator(1.5)}`};
  font-weight: 700;
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(1)}`};
`;

export const InputField = styled.div`
  border: ${props => `${viewSizeCalculator(0.0938)} solid ${props.error ? '#F34D4D' : '#b8b8b8'}`};
  border-radius: ${() => `${viewSizeCalculator(0.9375)}`};
  
  padding: ${() => `${viewSizeCalculator(0.5)} ${viewSizeCalculator(0.75)}`};
  
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.625)}`};
  
  height: ${() => `${viewSizeCalculator(3.125)}`};
`;

export const CustomInput = styled.input`
  outline: none;
  border: none;
  height: 100%;
  width: 80%;
  background-color: transparent;

  font-size: ${() => `${viewSizeCalculator(0.8125)}`};
  font-weight: 400;
`;

export const Section = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.3125)}`};

  font-size: ${() => `${viewSizeCalculator(0.8125)}`};

  cursor: pointer;
`;

export const ForgotPassword = styled.div`
  font-weight: 400;
  font-size: ${() => `${viewSizeCalculator(0.8125)}`};
  text-decoration: underline;
  cursor: pointer;
`;

export const LoginButton = styled.button`
  height: ${() => `${viewSizeCalculator(2.5)}`};
  border-radius: ${() => `${viewSizeCalculator(1.25)}`};
  padding : ${() => `${viewSizeCalculator(0.3125)} ${viewSizeCalculator(1.6875)}`};

  border: none;
  outline: none;
  background-color: ${props => props.disabled ? "#cccccc" : "#f96c50"};
  color: #ffffff;

  cursor: pointer;

  font-size: ${() => `${viewSizeCalculator(1)}`};
  font-weight: 500;

  &:hover {
    background-color: ${props => props.disabled ? "#cccccc" : "#f96c50"};
  }

  transition: all 0.2s ease-in-out;
`;

export const OtherLoginContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Line = styled.div`
  /* border: 1px solid #333333; */
  opacity: 10%;

  z-index: 99;
`;

export const Text = styled.p`
  font-size: ${() => `${viewSizeCalculator(0.75)}`};
  font-weight: 400;
  opacity: 60%;

  z-index: 1000;
`;

export const SocialButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(1)}`};
`;

export const SocialLoginButton = styled.button`
  height: ${() => `${viewSizeCalculator(2.5)}`};
  border-radius: ${() => `${viewSizeCalculator(1.25)}`};
  padding : ${() => `${viewSizeCalculator(0.3125)} ${viewSizeCalculator(1.6875)}`};

  border: 1px solid #b8b8b8;
  outline: none;

  cursor: pointer;

  font-size: ${() => `${viewSizeCalculator(1)}`};
  font-weight: 400;

  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: #fbfbfb;
  }

  transition: all 0.2s ease-in-out;
`;

export const LogoTextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  gap: ${() => `${viewSizeCalculator(0.5)}`};
`;

export const NewAccountSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.3125)}`};

  font-size: ${() => `${viewSizeCalculator(0.75)}`};
  font-weight: 400;

  color: #858585;
`;

export const SignUpSpan = styled.div`
  color: #f96c50;

  font-weight: 500;
  font-size: ${() => `${viewSizeCalculator(0.75)}`};

  text-decoration: underline;
  
  cursor: pointer;
`;

export const ErrorText = styled.p`
  color: #F34D4D;
  font-size: ${() => `${viewSizeCalculator(0.75)}`};
  margin-top: ${() => `${viewSizeCalculator(0.25)}`};
  display:flex;
  align-items:center;
  gap:3px;
`;
